var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_vm._v(" "),_c('meta',{attrs:{"http-equiv":"X-UA-Compatible","content":"IE=edge"}}),_vm._v(" "),_c('meta',{attrs:{"name":"viewport","content":"width=device-width, initial-scale=1.0"}}),_vm._v(" "),_c('main',{staticClass:"app-content"},[_c('h52',[_c('span',{staticClass:"txt-rotate2",attrs:{"data-period":"4000","data-rotate2":"[ \"ASLAN ENERGY MADENCİLİK\", \"MUSTAFA ASLAN\"]"}})])],1),_vm._v(" "),_c('Sidebar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e236946","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Homepage.vue
// module id = 124
// module chunks = 0